import createImageUrlBuilder from '@sanity/image-url';
import { createClient } from 'next-sanity';

import config from './store';

if (!config.projectId) {
  throw Error('The Project ID is not set. Check your environment variables.');
}

export const urlFor = source => createImageUrlBuilder(config).image(source);
export const imageBuilder = source => createImageUrlBuilder(config).image(source);

// export const client = createClient({ ...config });
export const client = createClient({ ...config, token: '' });

// Preview client can still use the token from the store if needed for previews
// It will pick up NEXT_PUBLIC_SANITY_TOKEN via the `...config` spread
export const previewClient = createClient({
  ...config,
  useCdn: false, // Previews should typically not use CDN
});

export const getClient = usePreview => (usePreview ? previewClient : client);

export default client;
